export const INSTITUTION_ROUTE_PREFIX = "/admin/institutions";

export const INSTITUTION_ROUTE_PATHS = {
  list: { path: "*", to: INSTITUTION_ROUTE_PREFIX },
  create: { path: "new", to: `${INSTITUTION_ROUTE_PREFIX}/new` },
  detail: { path: ":id", to: `${INSTITUTION_ROUTE_PREFIX}/:id` },
};
